module.exports = __webpack_public_path__ + "img/3.3.99b83e3d.png";